import type { ContentProps } from '@studio/design-system/tabs';
import { Content as _Content } from '@studio/design-system/tabs';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';

/** `<Content>` component. */
export const Content = ({ children, className, ...props }: ContentProps): ReactElement => (
  <_Content className={twMerge('grow', className)} {...props}>
    {children}
  </_Content>
);
